/*
 * A 2px accent line on the header's bottom edge, with no track: it was the loudest element on the screen as a
 * white bar of its own. The header wrapper is the containing block.
 */
.progressBar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;
  height: 2px;
  pointer-events: none;
}

.progressFill {
  height: 100%;
  background: var(--tuna-palette-primary-main);
  transition: width 0.3s linear;
}

@media (prefers-reduced-motion: reduce) {
  .progressFill {
    transition: none;
  }
}
